/**
 * Serializes object keys in deterministic order for runtime cache keys and
 * other block contract comparisons.
 */
export const stableStringify = (value) => {
    if (value === null || typeof value !== 'object')
        return JSON.stringify(value);
    if (Array.isArray(value))
        return `[${value.map((entry) => stableStringify(entry)).join(',')}]`;
    const source = value;
    return `{${Object.keys(source)
        .sort()
        .map((key) => `${JSON.stringify(key)}:${stableStringify(source[key])}`)
        .join(',')}}`;
};
/**
 * Builds a deterministic cache key from primitive and structured block runtime
 * inputs.
 */
export const buildRuntimeCacheKey = (...parts) => parts.map((part) => (typeof part === 'string' || typeof part === 'number' ? String(part) : stableStringify(part))).join('::');
